import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * KPI tile row — four stat tiles across the top of the dashboard.
 * Pastel icon chip + big number + label. Trend percentages are
 * deliberately omitted until we have comparison data to drive them.
 */
import React from 'react';
import { Card, Col, Row, Skeleton, Typography } from 'antd';
import { TeamOutlined, UsergroupAddOutlined, PlayCircleOutlined, TrophyOutlined, } from '@ant-design/icons';
import { PALETTE } from './helpers';
const { Text } = Typography;
export function KpiRow({ data, loading }) {
    const k = data?.kpi;
    const tiles = [
        { label: 'תלמידים רשומים', value: k?.registered_students ?? null,
            icon: _jsx(TeamOutlined, {}), chipBg: PALETTE.lavAlt, chipFg: PALETTE.purpleDeep },
        { label: 'פעילים היום', value: k?.active_today ?? null,
            icon: _jsx(UsergroupAddOutlined, {}), chipBg: PALETTE.mintSoft, chipFg: '#0a7a52' },
        { label: 'צפיות בקליפים היום', value: k?.clip_views_today ?? null,
            icon: _jsx(PlayCircleOutlined, {}), chipBg: PALETTE.amberSoft, chipFg: '#8a5a00' },
        { label: 'בחנים שעברו היום', value: k?.exams_passed_today ?? null,
            icon: _jsx(TrophyOutlined, {}), chipBg: PALETTE.skySoft, chipFg: '#1849a9' },
    ];
    return (_jsx(Row, { gutter: [16, 16], children: tiles.map((t) => (_jsx(Col, { xs: 24, sm: 12, xl: 6, children: _jsx(Card, { styles: { body: { padding: 20 } }, children: _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 14 }, children: [_jsx("span", { style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 48,
                                height: 48,
                                borderRadius: 14,
                                background: t.chipBg,
                                color: t.chipFg,
                                fontSize: 22,
                                flex: '0 0 auto',
                            }, children: t.icon }), _jsxs("div", { style: { minWidth: 0, flex: 1 }, children: [_jsx(Text, { style: { fontSize: 13, color: PALETTE.inkMuted, display: 'block' }, children: t.label }), loading && t.value === null ? (_jsx(Skeleton.Input, { active: true, size: "small", style: { width: 80, marginTop: 6 } })) : (_jsx(Text, { style: {
                                        fontSize: 28,
                                        fontWeight: 700,
                                        color: PALETTE.ink,
                                        lineHeight: 1.1,
                                        display: 'block',
                                    }, children: (t.value ?? 0).toLocaleString('he-IL') }))] })] }) }) }, t.label))) }));
}
